import { getTimeParts } from "components/CustomTimePicker/utils";
import ReservationDurationData from "views/components/Schedules/components/UpdateActivityPopup/components/ReservationDurationData";

const SpaceDurationData = ({
	schedule
}) => {
    const duration = {
        date: schedule.date,
        timeParts: {
            start: getTimeParts(schedule.timeStart), 
            end: getTimeParts(schedule.timeEnd)
        }
    };
	return (
		<ReservationDurationData
			duration={duration} 
			gap="10px"/>
	);
}

export default SpaceDurationData;